import { CheckCircle2Icon } from "lucide-react";

// Success banner shown once every step has a green submission.
export function CompletionBanner({ title }: { title?: string }) {
  return (
    <div className="flex items-start gap-3 rounded-lg border border-green-200 bg-green-50 p-4 dark:border-green-800 dark:bg-green-950/30">
      <CheckCircle2Icon className="size-6 shrink-0 text-green-600" />
      <div>
        <p className="font-semibold text-green-800 dark:text-green-300">
          {title ?? "Lab complete"}
        </p>
        <p className="text-sm text-green-700/90 dark:text-green-400/90">
          Every step verified and reviewed. Nothing is left running on your machine.
        </p>
      </div>
    </div>
  );
}
